class ProductCheckboxElement extends HTMLElement {
  connectedCallback() {
    this.setup();
  }

  initEvents() {
    this.checkbox.addEventListener('input', () => {
      this.updateCheckboxState();
    });
  }

  // Dispatches an event to the parent element to update the add to cart button
  updateCheckboxState() {
    this.dispatchEvent(
      new CustomEvent('pxl:productCheckboxChange', {
        detail: {
          selected: this.checkbox.checked
        },
        bubbles: true,
        composed: true
      })
    );
  }

  setup() {
    this.checkbox = this.querySelector('[data-kyoto-only-product-checkbox]');
    this.initEvents();

    // Add pageshow event listener
    window.addEventListener('pageshow', () => {
      this.updateCheckboxState();
    });
  }
}

customElements.get('product-checkbox-element') ||
  customElements.define('product-checkbox-element', ProductCheckboxElement);
